import { CUSTOMIZE_TYPES } from "@shared/constants";

const getId360ViewConfig = (activePreConfiguration, activeAccessory, car) => {
  const id360ViewPreconfiguration = activePreConfiguration.id360View;
  const id360ViewAccessories = [];

  const { options: activePreConfigurationOptionIds } = activePreConfiguration;
  const { options: carConfigurationOptions } = car;

  for (const carConfigurationOption of carConfigurationOptions) {
    if (activePreConfigurationOptionIds?.includes(carConfigurationOption.id)) {
      // Collect personalizations
      if (carConfigurationOption.type === CUSTOMIZE_TYPES.PERSONALIZATION) {
        id360ViewAccessories.push(carConfigurationOption.id);

        continue;
      }

      // Collect accessories which are currently selected
      if (carConfigurationOption.type === CUSTOMIZE_TYPES.ACCESSORY) {
        const accessory = activeAccessory.find(
          accessory => accessory.id === carConfigurationOption.id
        );
        if (accessory) {
          id360ViewAccessories.push(accessory.id360View);

          continue;
        }
      }

      // Collect personalizations included in the packs
      if (carConfigurationOption.type === CUSTOMIZE_TYPES.PACK) {
        for (const personalizationOption of carConfigurationOption.personalizationOptions) {
          const option = carConfigurationOptions.find(
            option => option.id === personalizationOption.id
          );
          if (option) {
            id360ViewAccessories.push(option.id360View);
          }
        }
      }
    }
  }

  return {
    id360ViewAccessories,
    id360ViewPreconfiguration,
  };
};

export { getId360ViewConfig };
